var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGgSearchIcon = function SvgGgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0089FF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m3.854 7.354a.5.5 0 0 1-.708 0l-3.129-3.13a5.5 5.5 0 1 1 .708-.707l3.129 3.13a.5.5 0 0 1 0 .707M11 15.5a4.5 4.5 0 1 0 0-9.001 4.5 4.5 0 0 0 0 9"
  })));
};
export default SvgGgSearchIcon;